import React, { useState, useEffect } from 'react';
import './styles.css';
import { CheckIcon } from '../PricingCard/icons';
import { useTheme } from '../../../ui/src/contextProviders';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { Loader, SuccessModal } from '@ohif/ui';
import { _purchase_type } from '@custom/Utils/constants/appConstants';
import createStripePortalSession from '@custom/rtk-apis/payement-gateway/createStripeSession';
import { getAddons } from '@custom/rtk-apis/Setting/addons/getAddons';

interface AddOnSelectionPopupProps {
  formAddons: any[];
  getAddonsResponse: any;
  isOpen: boolean;
  onClose: () => void;
  isMonthly?: boolean;
}

const AddOnSelectionPopup: React.FC<AddOnSelectionPopupProps> = ({
  formAddons,
  getAddonsResponse,
  isOpen,
  onClose,
  isMonthly = true
}) => {
  const { isDarkMode } = useTheme();
  const dispatch = useDispatch<AppDispatch>();

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  interface SelectedAddOn {
    id: string;
  }

  const [selectedAddOns, setSelectedAddOns] = useState<SelectedAddOn[]>([]);

  const toggleAddOn = (addon) => {
    setSelectedAddOns(prev => {
      if (prev.some(item => item.id === addon?._id)) {
        return prev.filter(item => item.id !== addon?._id);
      } else {
        return [...prev, { id: addon?._id, name: addon?.name }];
      }
    });
  };

  const handleContinue = () => {
    const selectedAddOnsDetails = formAddons
      .filter(addon => selectedAddOns.some(item => item.id === addon._id))
      .map(addon => ({
        id: addon._id,
        name: addon.name,
        price: addon.price,
        features: addon.features.map(feature => feature.point),
        code : addon.code
    }));

    // Calculate total price
    const totalPrice = selectedAddOnsDetails.reduce((sum, addon) => sum + addon.price, 0);

    const hospitalCode = sessionStorage.getItem('hospitalCode') || localStorage.getItem('hospitalCode')

    const selectedAddOnsCode = selectedAddOnsDetails.map(addon => {return {[`${addon.code}`]:true}});

    const payload = {
      product_name: "ADDONS-SERVICES",
      product_amount: totalPrice,
      purchase_type: _purchase_type.ADD_ONS,
      hospital_code: hospitalCode,
      servicesEnabled: selectedAddOnsCode[0]
    };

    dispatch(createStripePortalSession(payload)).catch((error) => {
      console.error('Error creating Stripe portal session:', error);
      // setLoading(false);
    });
  };

  if (!isOpen) return null;

  return (
    <div className={`addon-modal-overlay ${isDarkMode ? 'dark-mode' : ''}`} onClick={onClose}>
      <div className={`addon-modal-content ${isDarkMode ? 'dark-mode' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className={`addon-modal-header ${isDarkMode ? 'dark-mode' : ''}`}>
          <h2 className={isDarkMode ? 'dark-mode' : ''}>Select Add-ons</h2>
          <button className={`close-button ${isDarkMode ? 'dark-mode' : ''}`} onClick={onClose}>×</button>
        </div>

        <div className="addon-cards-container">
          {formAddons?.map((addon) => (
            <div
              className={`addon-card ${selectedAddOns?.some(item => item.id === addon._id) ? 'selected' : ''} ${isDarkMode ? 'dark-mode' : ''}`}
              key={addon?._id}
              onClick={() => toggleAddOn(addon)}
            >
              <div className="addon-card-checkbox">
                <input
                  type="checkbox"
                  checked={selectedAddOns.some(item => item.id === addon?._id)}
                  onChange={() => toggleAddOn(addon)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div className={`addon-card-header ${isDarkMode ? 'dark-mode' : ''}`}>
                {/* {addon.recommended && <div className="recommended-badge">Recommended</div>} */}
                <h3 className={isDarkMode ? 'dark-mode' : ''}>{ addon?.name}</h3>
                <p className="price">+₹{addon?.price}/{isMonthly ? 'mo' : 'yr'}</p>
              </div>

              <div className={`addon-card-body ${isDarkMode ? 'dark-mode' : ''}`}>
                <ul className="features-list">
                  {addon?.features?.map((feature, index) => (
                    <li className={`feature-item ${isDarkMode ? 'dark-mode' : ''}`} key={index}>
                      <CheckIcon />
                      <span className={isDarkMode ? 'dark-mode' : ''}>{feature?.point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="addon-modal-footer">
          <button
            className="continue-btn"
            type="button"
            disabled={selectedAddOns.length === 0}
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
      <Loader
        isLoaderOpen={getAddonsResponse?.loading}
        handleCloseModal={() => {}}
      />
      <SuccessModal
        isSuccessModalOpen={showSuccessModal}
        title="Add-ons selected successfully"
        handleCloseModal={() => {
          setShowSuccessModal(false);
        }}
      />
    </div>
  );
};

export default AddOnSelectionPopup;
